/**
 * Created by zhouxuwang on 2021/12/10
 */

export default function tabItemSchemaHandle (props) {
  return {
    _type: 'tab-item',
    viewComponentName: 'tab-item-render',
    props: props.name
    // apiName
  }
}

export const tabItemProps = {
  // tab-item name
  label: String,
  // tab-item 标识
  name: String,
  // tab-item name后的整个单据数量
  count: Number
}
